// extracted by mini-css-extract-plugin
module.exports = {"main":"protected_main__ZPUfD"};